import RuleState from 'app/stores/interface/RuleState';
import { observable } from 'mobx';

export class RuleTestState extends RuleState {
  @observable
  totalPercentClassified = 0;
}
